import {Injector, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({ name: 'statepipe' })
export class StatePipe implements PipeTransform {

  constructor(private injector: Injector) {}

  transform(state: number | string): number | string {

    // Load Service into Pipe
    const _translate = this.injector.get(TranslateService);

    if (state) {
      state = Number(state);

      // TODO: RENAME STATE NUMBERS TO MATCHING STATE NAME ALSO IN LANGUAGE JSON FILE (DE, EN, CZ)
      switch (state) {
        case 0: {
          return _translate.instant('state.STATE_ZERO');
        }
        case 1: {
          return _translate.instant('state.STATE_ONE');
        }
        default: {
          return _translate.instant('state.STATE_DEFAULT');
        }
      }
    } else {
      return _translate.instant('state.STATE_DEFAULT');
    }
  }
}
